export const REQUEST_ASSIGNED_CLAIMS_BY_SUB_SERVICES =
  'REQUEST_ASSIGNED_CLAIMS_BY_SUB_SERVICES';

export const SET_ASSIGNED_CLAIMS_BY_SUB_SERVICES =
  'SET_ASSIGNED_CLAIMS_BY_SUB_SERVICES';

export const REQUEST_ASSIGN_CLAIM_TO_MANAGER =
  'REQUEST_ASSIGN_CLAIM_TO_MANAGER';
export const MANAGER_ASSIGNMENTS_LABELS = [
  {
    title: 'PV',
    step: 'PROCES_VERBAL',
  },
  {
    title: 'Jugement ADD',
    step: 'JUDGEMENT_ADD',
    procedureType: 'FIRST_INSTANCE',
  },
  {
    title: "Rapport d'expertise judiciaire",
    step: 'EXPERT_REPORT',
    procedureType: 'FIRST_INSTANCE',
  },
  {
    title: 'Jugement au fond',
    step: 'JUDGEMENT_ON_MERITS',
    procedureType: 'FIRST_INSTANCE',
  },
  {
    title: 'Arrêt Add',
    step: 'JUDGEMENT_ADD',
    procedureType: 'APPEAL',
  },
  {
    title: "Rapport d'expertise judiciare",
    step: 'EXPERT_REPORT',
    procedureType: 'APPEAL',
  },
  {
    title: 'Arrêt Au fond',
    step: 'JUDGEMENT_ON_MERITS',
    procedureType: 'APPEAL',
  },
];
